<template>
  <Modal
      v-model="_value"
      width="400"
      title="确认收款"
      @on-visible-change="visibleChange"
      ok-text="确认"
      @on-ok="onOk">
    <Form ref="renewalOrderForm" :model="jt808ServCombineOrder">
      <FormItem prop="serviceDatetime">
        <Col span="6">
          <label>服务到期日期</label>
        </Col>
        <Col span="18">
          <DatePicker type="date" style="width: 100%;" v-model="jt808ServCombineOrder.serviceDatetime"
                      placeholder="选择日期"></DatePicker>
        </Col>
      </FormItem>
      <FormItem prop="receptDatetime">
        <Col span="6">
          <label>收款日期</label>
        </Col>
        <Col span="18">
          <DatePicker type="date" style="width: 100%;" v-model="jt808ServCombineOrder.receptDatetime"
                      placeholder="选择日期"></DatePicker>
        </Col>
      </FormItem>
      <FormItem prop="totalAmount">
        <Col span="6">
          <label>总金额</label>
        </Col>
        <Col span="18">
          <InputNumber :min="0" style="width: 100%;" v-model="jt808ServCombineOrder.totalAmount"
                       placeholder="请输入总金额">
          </InputNumber>
        </Col>
      </FormItem>
      <FormItem prop="billType">
        <Col span="6">
          <label>开票类型</label>
        </Col>
        <Col span="18">
          <Select style="width: 100%;" v-model="jt808ServCombineOrder.billType">
            <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Col>
      </FormItem>
      <FormItem prop="remark">
        <Col span="6">
          <label>备注</label>
        </Col>
        <Col span="18">
          <Input style="width: 100%;" v-model="jt808ServCombineOrder.remark"
                 type="textarea"
                 placeholder="请输入备注"></Input>
        </Col>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'jt808servcombineorderconfirmreceptmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      jt808ServCombineOrder: {
        id: null,
        serviceDatetime: null,
        billType: 1,
        totalAmount: 0,
        remark: null
      },
      billType: [
        { label: '增值税发票', value: 1 },
        { label: '增值税专用发票', value: 2 },
        { label: '增值税普通发票', value: 3 },
        { label: '增值税电子专用发票', value: 4 },
        { label: '增值税电子普通发票', value: 5 }
      ]
    }
  },
  methods: {
    ...mapActions([
      'RenewalOrderServ_ConfirmRecept'
    ]),
    onOk () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认服务期</p>',
        onOk: () => {
          store.dispatch('Jt808ServCombineOrderServ_ConfirmRecept',
            { params: this.jt808ServCombineOrder }).then(() => {
            this.$Message.success('确认成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.jt808ServCombineOrder.id = null
        this.jt808ServCombineOrder.serviceDatetime = null
        this.jt808ServCombineOrder.receptDatetime = null
        this.jt808ServCombineOrder.billType = 1
        this.jt808ServCombineOrder.receptDatetime = null
        this.jt808ServCombineOrder.totalAmount = 0
        this.jt808ServCombineOrder.remark = null

        let jt808ServCombineOrderId = this._initValue
        if (jt808ServCombineOrderId) {
          store.dispatch('Jt808ServCombineOrderServ_GetDetail', {
            params: { id: jt808ServCombineOrderId }
          }).then(() => {
            this.jt808ServCombineOrder = store.getters.get_Jt808ServCombineOrder_GetDetailResult
            this.jt808ServCombineOrder.serviceDatetime = new Date(this.jt808ServCombineOrder.serviceDatetime)
            this.jt808ServCombineOrder.receptDatetime = new Date()
            this.jt808ServCombineOrder.remark = null
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
